import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Form,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import { MDBDataTable } from "mdbreact";
import { useParams } from "react-router-dom";

const Prontuario = ({ pacienteId }) => {
  const [diagnostico, setDiagnostico] = useState("");
  const [tratamento, setTratamento] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [sintomas, setSintomas] = useState("");
  const [medicamentos, setMedicamentos] = useState("");
  const [examesSolicitados, setExamesSolicitados] = useState("");
  const [alergias, setAlergias] = useState("");
  const [intervencoes, setIntervencoes] = useState("");
  const [recomendacoesLifestyle, setRecomendacoesLifestyle] = useState("");
  const [planoAcompanhamento, setPlanoAcompanhamento] = useState("");

  const [modal, setModal] = useState(false);
  const [modalLeitura, setModalLeitura] = useState(false);
  const [selectedProntuario, setSelectedProntuario] = useState(null);
  const [data, setData] = useState({
    columns: [
      { label: "ID", field: "id", sort: "asc", width: 150 },
      { label: "Diagnóstico", field: "diagnostico", sort: "asc", width: 150 },
      { label: "Data", field: "created_at", sort: "asc", width: 150 },
      { label: "Ações", field: "acoes", width: 150 },
    ],
    rows: [],
  });

  const limitText = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // Função para buscar prontuários
  const fetchProntuarios = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/prontuarios/cliente/${pacienteId}`
      );
      const prontuarios = await response.json();
      const rows = prontuarios.map((prontuario) => ({
        id: prontuario.id,
        diagnostico: limitText(prontuario.descricao_prontuario, 15),
        created_at: new Date(prontuario.created_at).toLocaleDateString(),
        acoes: (
          <div>
            <Button
              size="sm"
              color="info"
              onClick={() => toggleModalProntuarioLeitura(prontuario)}
            >
              Visualizar
            </Button>{" "}
            <Button
              size="sm"
              color="warning"
              onClick={() => toggleModalProntuario(prontuario)}
            >
              Editar
            </Button>{" "}
            <Button
              size="sm"
              color="danger"
              onClick={() => handleDelete(prontuario.id)}
            >
              Excluir
            </Button>
          </div>
        ),
      }));
      setData((prevData) => ({ ...prevData, rows }));
    } catch (error) {
      toast.error("Erro ao buscar prontuários: " + error.message);
    }
  };

  useEffect(() => {
    fetchProntuarios();
  }, [pacienteId]);

  // Função para salvar prontuário (novo ou editado)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const method = selectedProntuario ? "PUT" : "POST";
      const url = selectedProntuario
        ? `${process.env.REACT_APP_API}/prontuarios`
        : `${process.env.REACT_APP_API}/prontuarios`;
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pacienteId,
          diagnostico,
          tratamento,
          observacoes,
          sintomas,
          medicamentos,
          examesSolicitados,
          alergias,
          intervencoes,
          recomendacoesLifestyle,
          planoAcompanhamento,
          id: selectedProntuario ? selectedProntuario.id : null,
        }),
      });

      if (response.ok) {
        toast.success("Prontuário cadastrado/atualizado com sucesso!");
        fetchProntuarios();
        toggleModalProntuario();
      } else {
        throw new Error("Falha ao cadastrar/atualizar prontuário.");
      }
    } catch (error) {
      toast.error("Erro ao cadastrar/atualizar prontuário: " + error.message);
    }
  };

  // Função para excluir prontuário
  const handleDelete = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/prontuarios/${id}`,
        {
          method: "DELETE",
        }
      );
      if (response.ok) {
        toast.success("Prontuário excluído com sucesso!");
        fetchProntuarios();
      } else {
        throw new Error("Falha ao excluir prontuário.");
      }
    } catch (error) {
      toast.error("Erro ao excluir prontuário: " + error.message);
    }
  };

  const substituirQuebraLinhas = (texto) => {
    console.log({ texto });

    return texto.replace(/\n/g, "<br>");
  };

  // Função para alternar o modal de edição
  const toggleModalProntuario = (prontuario = null) => {
    setSelectedProntuario(prontuario);
    if (prontuario) {
      setDiagnostico(prontuario.descricao_prontuario);
      setTratamento(prontuario.tratamento);
      setObservacoes(prontuario.observacoes);
      setSintomas(prontuario.sintomas);
      setMedicamentos(prontuario.medicamentos);
      setExamesSolicitados(prontuario.examesSolicitados);
      setAlergias(prontuario.alergias);
      setIntervencoes(prontuario.intervencoes);
      setRecomendacoesLifestyle(prontuario.recomendacoesLifestyle);
      setPlanoAcompanhamento(prontuario.planoAcompanhamento);
    } else {
      // Limpar campos
      setDiagnostico("");
      setTratamento("");
      setObservacoes("");
      setSintomas("");
      setMedicamentos("");
      setExamesSolicitados("");
      setAlergias("");
      setIntervencoes("");
      setRecomendacoesLifestyle("");
      setPlanoAcompanhamento("");
    }
    setModal(!modal);
  };

  // Função para alternar o modal de leitura
  const toggleModalProntuarioLeitura = (prontuario = null) => {
    setSelectedProntuario(prontuario);
    setModalLeitura(!modalLeitura);
  };

  return (
    <Card>
      <CardBody>
        <h3>Histórico do cliente</h3>

        <MDBDataTable striped responsive bordered data={data} />

        <Button color="primary" onClick={() => toggleModalProntuario()}>
          Novo Prontuário
        </Button>

        <Modal size="xl" isOpen={modal} toggle={() => toggleModalProntuario()}>
          <ModalHeader toggle={() => toggleModalProntuario()}>
            {selectedProntuario ? "Editar Prontuário" : "Novo Prontuário"}
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="diagnostico">História Clínica</Label>
                <Input
                  type="textarea"
                  rows="15"
                  name="diagnostico"
                  id="diagnostico"
                  value={diagnostico}
                  onChange={(e) => setDiagnostico(e.target.value)}
                />
              </FormGroup>
              <Button type="submit" color="primary">
                Salvar
              </Button>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => toggleModalProntuario()}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={modalLeitura}
          toggle={() => toggleModalProntuarioLeitura()}
        >
          <ModalHeader toggle={() => toggleModalProntuarioLeitura()}>
            Prontuário
          </ModalHeader>
          <ModalBody>
            {selectedProntuario && (
              <div>
                <p>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: substituirQuebraLinhas(
                        selectedProntuario.descricao_prontuario
                      ),
                    }}
                  ></span>
                </p>
                {/* <p>
                  <strong>Tratamento:</strong> {selectedProntuario.tratamento}
                </p>
                <p>
                  <strong>Observações:</strong> {selectedProntuario.observacoes}
                </p>
                <p>
                  <strong>Sintomas:</strong> {selectedProntuario.sintomas}
                </p>
                <p>
                  <strong>Medicamentos:</strong>{" "}
                  {selectedProntuario.medicamentos}
                </p>
                <p>
                  <strong>Exames Solicitados:</strong>{" "}
                  {selectedProntuario.examesSolicitados}
                </p>
                <p>
                  <strong>Alergias:</strong> {selectedProntuario.alergias}
                </p>
                <p>
                  <strong>Intervenções:</strong>{" "}
                  {selectedProntuario.intervencoes}
                </p>
                <p>
                  <strong>Recomendações de Lifestyle:</strong>{" "}
                  {selectedProntuario.recomendacoesLifestyle}
                </p>
                <p>
                  <strong>Plano de Acompanhamento:</strong>{" "}
                  {selectedProntuario.planoAcompanhamento}
                </p> */}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => toggleModalProntuarioLeitura()}
            >
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>
  );
};

export default Prontuario;
